import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function Blog() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">BoardVoyage Blog</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-lg text-gray-600 mb-6">
              Explore articles, guides, and stories from the board gaming community.
            </p>
            <div className="text-center py-12">
              <p className="text-gray-500 text-lg">
                Blog content coming soon! Stay tuned for gaming tips, reviews, and community stories.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blog;
